import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useDropzone } from 'react-dropzone';

// const api = axios.create({
//   baseURL: process.env.REACT_APP_API_URL,
//   timeout: 5000,
// });
import api from '../../services/api';

function RestaurantDetails() {
  const [formData, setFormData] = useState({
    name: '',
    address: '',
    description: '',
    image: null,
    optOutWord: '',
  });
  const [imagePreview, setImagePreview] = useState(null);
  const navigate = useNavigate();
  const { restaurantId } = useParams();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchRestaurantDetails();
  }, [restaurantId]);

  const fetchRestaurantDetails = async () => {
    try {
      const token = localStorage.getItem('ownerToken');
      const response = await api.get(`/restaurants/${restaurantId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log('Fetched restaurant details:', response.data);
      setFormData(response.data);
      if (response.data.profileImage) {
        setImagePreview(response.data.profileImage);
      }
      setFormData((prev) => ({
        ...prev,
        image: response.data.profileImage || null,
      }));
    } catch (error) {
      console.error('Error fetching restaurant details:', error);
      toast.error('Error fetching restaurant details. Please try again later.');
    }
  };

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prev) => ({ ...prev, [name]: value }));
  // };

  const handleInputChange = useCallback((field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  }, []);

  // const onDrop = useCallback((acceptedFiles) => {
  //   if (acceptedFiles[0]) {
  //     const reader = new FileReader();
  //     reader.onload = (e) => {
  //       setImagePreview(e.target.result);
  //       setFormData((prev) => ({ ...prev, image: e.target.result }));
  //     };
  //     reader.readAsDataURL(acceptedFiles[0]);
  //   }
  // }, []);

  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles[0]) {
      setFormData((prev) => ({ ...prev, image: acceptedFiles[0] }));
    }
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'image/jpeg': ['.jpg', '.jpeg'],
      'image/png': ['.png'],
      'image/gif': ['.gif'],
    },
    multiple: false,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem('ownerToken');
      const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      };
      const dataToSend = {
        name: formData.name,
        address: formData.address,
        description: formData.description,
        optOutWord: formData.optOutWord,
        // image: formData.image,
      };

      if (formData.image instanceof File) {
        dataToSend.image = formData.image;
      } else if (typeof formData.image === 'string') {
        dataToSend.existingImageUrl = formData.image;
      }
      // if (formData.image instanceof File) {
      //   console.log('formdata' + formData.image);
      // } else if (typeof formData.image === 'string') {
      //   console.log('formdata string' + formData.image);
      // }
      // console.log('formdata' + formData.image);
      console.log('Sending data to:', `/api/restaurants/${restaurantId}`);
      console.log('Data being sent:', dataToSend);

      const response = await api.patch(
        `/restaurants/${restaurantId}`,
        dataToSend,
        { headers }
      );

      console.log('Update response:', response.data);
      toast.success('Restaurant details updated successfully');
      fetchRestaurantDetails();
    } catch (error) {
      console.error('Error updating restaurant details:', error);
      if (error.response) {
        console.error('Response data:', error.response.data);
        console.error('Response status:', error.response.status);
        console.error('Response headers:', error.response.headers);
      }
      toast.error('Failed to update restaurant details');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    if (
      window.confirm(
        'Are you sure you want to delete this restaurant? This action cannot be undone.'
      )
    ) {
      try {
        const token = localStorage.getItem('ownerToken');
        await axios.delete(`/api/restaurants/${restaurantId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        toast.success('Restaurant deleted successfully');
        navigate('/owner/dashboard');
      } catch (error) {
        console.error('Error deleting restaurant:', error);
        toast.error('Failed to delete restaurant');
      }
    }
  };

  return (
    <div className='max-w-md mx-auto mt-10'>
      <h2 className='text-2xl font-bold mb-4'>Edit Restaurant Details</h2>
      <form onSubmit={handleSubmit} className='space-y-4'>
        <div>
          <label className='block text-sm font-medium text-gray-700'>
            Restaurant Name
          </label>
          <input
            type='text'
            name='name'
            value={formData.name}
            onChange={(e) => handleInputChange('name', e.target.value)}
            className='w-full p-2 border rounded'
            required
          />
        </div>
        <div>
          <label className='block text-sm font-medium text-gray-700'>
            Address
          </label>
          <input
            type='text'
            name='address'
            value={formData.address}
            onChange={(e) => handleInputChange('address', e.target.value)}
            className='w-full p-2 border rounded'
          />
        </div>
        <div>
          <label className='block text-sm font-medium text-gray-700'>
            Description (optional)
          </label>
          <textarea
            name='description'
            value={formData.description}
            onChange={(e) => handleInputChange('description', e.target.value)}
            className='w-full p-2 border rounded'
          />
        </div>
        <div>
          <label className='block text-sm font-medium text-gray-700'>
            Profile Image
          </label>
          <div
            {...getRootProps()}
            className={`dropzone border-2 border-dashed rounded-lg p-4 text-center cursor-pointer transition-colors duration-200 ease-in-out ${
              isDragActive
                ? 'border-indigo-600 bg-indigo-50'
                : 'border-gray-300 hover:border-indigo-400'
            }`}
          >
            <input {...getInputProps()} />
            {isDragActive ? (
              <p className='text-indigo-600'>Drop the image here ...</p>
            ) : (
              <div>
                <p className='text-gray-600'>
                  Drag 'n' drop an image here, or click to select one
                </p>
                <p className='text-sm text-gray-500 mt-1'>
                  Supported formats: JPG, PNG, GIF
                </p>
              </div>
            )}
          </div>
          {/* {imagePreview && (
            <div className='mt-2'>
              <img
                src={imagePreview}
                alt='Profile Preview'
                className='w-full h-32 object-cover rounded'
              />
            </div>
          )} */}
          {formData.image && (
            <div className='mt-4'>
              <h3 className='text-lg font-semibold mb-2'>Image Preview</h3>
              <img
                src={
                  formData.image instanceof File
                    ? URL.createObjectURL(formData.image)
                    : formData.image
                }
                alt='Uploaded preview'
                className='max-w-full h-auto rounded-lg shadow-md'
              />
            </div>
          )}
          {formData.image && (
            <div className='mt-2 flex items-center'>
              <span className='text-sm text-gray-600'>
                {formData.image instanceof File
                  ? formData.image.name
                  : 'Current image'}
              </span>
              <button
                type='button'
                onClick={() => handleInputChange('image', null)}
                className='ml-2 text-red-600 hover:text-red-800 text-sm'
              >
                Remove
              </button>
            </div>
          )}
        </div>
        <button
          type='submit'
          className='bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700 disabled:bg-indigo-300'
          disabled={loading}
        >
          {loading ? 'Updating...' : 'Update'}
        </button>
      </form>
      <div className='mt-8'>
        <h2 className='text-2xl font-bold mb-4'>Delete Restaurant</h2>
        <p className='text-red-600 mb-4'>
          Warning: This action cannot be undone.
        </p>
        <button
          onClick={handleDelete}
          className='bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600'
        >
          Delete Restaurant
        </button>
      </div>
    </div>
  );
}

export default RestaurantDetails;
// import React, { useState, useEffect } from 'react';
// import { useNavigate, useParams } from 'react-router-dom';
// import { createRestaurant } from '../../services/restaurantService';

// // import {
// //   // fetchRestaurantDetails,
// //   getRestaurant,
// //   deleteRestaurant,
// //   fetchRestaurantUnsubscribeLink,
// // } from '../../services/restaurantService';
// import axios from 'axios';
// import { toast } from 'react-toastify';

// function RestaurantDetails() {
//   const [name, setName] = useState('');
//   const [address, setAddress] = useState('');
//   const [description, setDescription] = useState('');
//   const [image, setimage] = useState(null);
//   const [optOutWord, setOptOutWord] = useState('');
//   const navigate = useNavigate();
//   const { restaurantId } = useParams();
//   const [loading, setLoading] = useState(false);
//   // const [error, setError] = useState('');
//   useEffect(() => {
//     fetchWelcomeMessage();
//   }, [restaurantId]);

//   const fetchWelcomeMessage = async () => {
//     try {
//       const token = localStorage.getItem('ownerToken');

//       const response = await axios.get(`/api/restaurants/${restaurantId}`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       // console.log(response.data);
//       setName(response.data.name);
//       setAddress(response.data.address);
//       setDescription(response.data.description);
//       setimage(response.data.image);
//     } catch (error) {
//       if (error.response && error.response.status !== 404) {
//         // console.error('Error fetching welcome message:', error);
//         toast.error(
//           'Error fetching data. Please try again later or contact support.'
//         );
//         // setError('Failed to fetch welcome message');
//       }
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     // setError('');
//     // setSuccessMessage('');

//     try {
//       const token = localStorage.getItem('ownerToken');

//       // console.log(image);
//       await axios.put(
//         `/api/restaurants/${restaurantId}`,
//         {
//           name,
//           address,
//           description,
//           image,
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );
//       // setSuccessMessage('Welcome message saved successfully');
//       toast.success('Saved');
//     } catch (error) {
//       console.error('Error saving welcome message:', error);
//       // setError('Failed to save welcome message');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // const handleSubmit = async (e) => {
//   //   e.preventDefault();
//   //   const formData = new FormData();
//   //   formData.append('name', name);
//   //   formData.append('address', address);
//   //   formData.append('description', description);
//   //   if (image) {
//   //     formData.append('image', image);
//   //   }
//   //   try {
//   //     await createRestaurant({
//   //       name,
//   //       address,
//   //       description,
//   //       image,
//   //       optOutWord,
//   //     });
//   //     navigate('/owner/dashboard');
//   //   } catch (error) {
//   //     alert('Failed to create restaurant.');
//   //   }
//   // };

//   const handleImageChange = (e) => {
//     console.log(e.target.files);
//     setimage(e.target.files[0]);
//   };

//   return (
//     <div className='max-w-md mx-auto mt-10'>
//       <h2 className='text-2xl font-bold mb-4'>Edit Restaurant Details</h2>
//       <form onSubmit={handleSubmit} className='w-full max-w-md'>
//         <div className='mb-4'>
//           <label className='block text-sm font-medium text-gray-700'>
//             Restaurant Name
//           </label>
//           <input
//             type='text'
//             value={name}
//             onChange={(e) => setName(e.target.value)}
//             className='w-full p-2 border rounded'
//           />
//         </div>
//         <div className='mb-4'>
//           <label className='block text-sm font-medium text-gray-700'>
//             Address
//           </label>
//           <input
//             type='text'
//             value={address}
//             onChange={(e) => setAddress(e.target.value)}
//             className='w-full p-2 border rounded'
//           />
//         </div>
//         <div className='mb-4'>
//           <label className='block text-sm font-medium text-gray-700'>
//             Description (optional)
//           </label>
//           <textarea
//             value={description}
//             onChange={(e) => setDescription(e.target.value)}
//             className='w-full p-2 border rounded'
//           />
//         </div>
//         <div className='mb-4'>
//           <label className='block text-sm font-medium text-gray-700'>
//             Profile Image
//           </label>
//           <input
//             type='file'
//             onChange={handleImageChange}
//             className='w-full p-2'
//           />
//         </div>
//         <button
//           type='submit'
//           className='bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700'
//         >
//           Update
//         </button>
//       </form>
//       <h2 className='text-2xl font-bold mb-4 mt-8'>Delete Restaurant</h2>
//       <h4 className='text-md font-bold mb-4 text-gray-700'>
//         You will lose all your data: subscribers, coupons, and messages
//       </h4>
//       <button
//         // onClick={handleDelete}
//         className='bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600'
//       >
//         Delete
//       </button>
//     </div>
//   );
// }

// export default RestaurantDetails;

// import React, { useEffect, useState } from 'react';
// import { useParams, Link } from 'react-router-dom';
// import {
//   // fetchRestaurantDetails,
//   getRestaurant,
//   deleteRestaurant,
//   fetchRestaurantUnsubscribeLink,
// } from '../../services/restaurantService';

// function RestaurantDetails() {
//   const { restaurantId } = useParams();
//   const [restaurant, setRestaurant] = useState(null);
//   const [unsubscribeLink, setUnsubscribeLink] = useState('');

//   useEffect(() => {
//     const loadRestaurantDetails = async () => {
//       const response = await getRestaurant(restaurantId);
//       setRestaurant(response.data);
//     };
//     loadRestaurantDetails();

//     // const loadUnsubscribeLink = async () => {
//     //   const response = await fetchRestaurantUnsubscribeLink(restaurantId);
//     //   setUnsubscribeLink(response.data.unsubscribeLink);
//     // };
//     // loadUnsubscribeLink();
//   }, [restaurantId]);

//   const handleDelete = async () => {
//     if (window.confirm('Are you sure you want to delete this restaurant?')) {
//       await deleteRestaurant(restaurantId);
//       // Redirect to owner dashboard or show a confirmation message
//     }
//   };

//   return (
//     <div className='p-4'>
//       {restaurant && (
//         <>
//           <h1 className='text-2xl font-bold mb-4'>{restaurant.name}</h1>
//           <p>{restaurant.description}</p>
//           <p>Address: {restaurant.address}</p>
//           <div className='mt-4'>
//             <Link
//               to={`/restaurants/${restaurantId}/edit`}
//               className='bg-blue-500 text-white px-4 py-2 rounded mr-2'
//             >
//               Edit Restaurant
//             </Link>
//             <button
//               onClick={handleDelete}
//               className='bg-red-500 text-white px-4 py-2 rounded'
//             >
//               Delete Restaurant
//             </button>
//           </div>
//           <div className='mt-4'>
//             <h2 className='text-xl font-semibold'>Unsubscribe Link</h2>
//             <p>{unsubscribeLink}</p>
//           </div>
//         </>
//       )}
//     </div>
//   );
// }

// export default RestaurantDetails;
